// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rnYZ","controls":"styles_controls__2Pw8h","charLimit":"styles_charLimit__2320U","input":"styles_input__VYhb1","send":"styles_send__3BaQ_"};